<template>
  <div
    class="inline-batch-card"
    v-on="$listeners"
  >
    <div class="inline-batch-card-data">
      <div class="inline-batch-card-data-list">
        <div class="inline-batch-card-data-list-item">
          <div class="inline-batch-card-data-label">
            Lote:
          </div>

          <div class="inline-batch-card-data-value">
            <div class="mnemonic-badge">
              {{ batch.label + '.' + batch.sequence }}
            </div>
          </div>
        </div>

        <div class="inline-batch-card-data-list-item">
          <div class="inline-batch-card-data-label">
            Código:
          </div>

          <div class="inline-batch-card-data-value">
            {{ batch.barcode }}
          </div>
        </div>

        <div class="inline-batch-card-data-list-item">
          <div class="inline-batch-card-data-label">
            Data:
          </div>

          <div class="inline-batch-card-data-value">
            {{ batch.created_at | date }}
          </div>
        </div>
      </div>

      <div class="inline-batch-card-data-packaging">
        <div :class="['inline-batch-card-data-packaging-box', packaging.colorClass]">
          <md-icon
            :md-src="packaging.iconSrc"
            class="inline-batch-card-data-packaging-icon"
          />
        </div>
      </div>
    </div>

    <div class="inline-batch-card-separator" />

    <div class="inline-batch-card-samples-amount">
      <div class="inline-batch-card-samples-amount-value">
        {{ batch.total_samples }}
      </div>

      <div class="inline-batch-card-samples-amount-label">
        {{ samplesAmountLabel }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import strings from '@/strings'

export default {
  name: 'InlineBatchCard',
  filters: {
    date: (value) => moment(value).format('DD-MM-YYYY')
  },
  props: {
    batch: {
      type: Object,
      required: true
    }
  },
  computed: {
    samplesAmountLabel() {
      return ['Amostras', 'Amostra', 'Amostras'][this.batch.total_samples] ?? 'Amostras'
    },
    packaging() {
      let packaging = strings.packagingStatus.find(packaging => packaging.id === this.batch.packagingId)

      if (packaging) {
        packaging = {
          id: packaging.id,
          name: packaging.name,
          iconSrc: `/static/images/icon-${packaging.state}.svg`,
          colorClass: packaging.color
        }
      }

      return packaging
    }
  }
}
</script>

<style lang="scss" scoped>
.inline-batch-card {
  display: flex;
  padding: 1rem;
  gap: 0.5rem;
  font-family: 'Exo 2', sans-serif;
  border-radius: 0.25rem;
  box-shadow: 0px 4px 10px 0px #8181810D;
  background-color: #FFFFFF;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #E6E6E6;
  }

  &-data {
    flex: 1;
    display: flex;
    gap: 1rem;
    color: #818181;

    &-list {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      &-item {
        display: flex;
        gap: 0.5rem;
      }
    }

    &-label {
      font-weight: 700;
      text-transform: uppercase;
      font-size: 0.75rem;
    }

    &-value {
      font-weight: 500;
      font-size: 0.75rem;
    }

    &-packaging {
      &-box {
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 0.1875rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-icon {
        width: 1.25rem;
        height: 1.25rem;
        min-width: auto;
        min-height: auto;
      }
    }
  }

  &-separator {
    width: 1px;
    background-color: #CCCCCC;
  }

  &-samples-amount {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 80px;

    &-value {
      font-weight: 700;
      font-size: 1.75rem;
      color: #FFBF00;
    }

    &-label {
      text-transform: uppercase;
      color: #818181;
    }
  }
}

.mnemonic-badge {
  background-color: #4a4a4a;
  border-radius: 2px;
  color: white;
  padding: 1px 6px;
  font-family: 'Exo 2';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  opacity: 0.93;
  text-transform: uppercase;
}
</style>
